import React, { Component } from 'react';
import { TextField } from '@material-ui/core';

/**
 * region for hepers*/
import typing from '../../../helpers/typing';


class BasicDetailsName extends Component {
    state = {
        name: "",
        error: false
    };

    componentWillReceiveProps(nextProps) {
        this.setState({ name: nextProps.name, error: nextProps.nameError });
    }

    onChange = (e) => {
        let error = false;
        if (typing.isEmpty( e.target.value)) {
            error = true;
        }
        this.setState({ name: e.target.value, error: error });
    }  
 
    onBlur = (e) => {
        this.props.onAttributeUpdate({ name: this.state.name }, this.state.error, e.target.id )
    }

    render() {
        const { name, error } = this.state;
        return (
            <TextField
                label="NAME"
                id="name"
                style={{ marginTop: 8,marginBottom:8 }}
                placeholder="The name for this mini-site"
                fullWidth
                margin="normal"
                error={error}
                value={name}
                onBlur={this.onBlur}
                onChange={this.onChange}
                InputLabelProps={{
                    shrink: true,
                }}
            />
        )
    }
};
export default BasicDetailsName;